import {allowedChars, allowedCharsEng} from "@pp-frontend/shared-packages/utils/validations"

const autoTranslate = (v) => {
  const engLetters = allowedCharsEng
  const translations = {
    A: 'А',
    B: 'В',
    E: 'Е',
    K: 'К',
    M: 'М',
    H: 'Н',
    O: 'О',
    P: 'Р',
    C: 'С',
    T: 'Т',
    Y: 'У',
    X: 'Х'
  }
  if (engLetters.includes(v)) {
    return translations[v.toLocaleUpperCase()]
  }
  return v.toLocaleUpperCase()
}

export const maskTokens = {
  '#': { pattern: /\d/ },
  f: {
    pattern: new RegExp(`[${allowedChars}]`),
    transform: autoTranslate
  },
  F: {
    pattern: new RegExp(`[0-9${allowedChars}]`),
    transform: autoTranslate
  }
}
